// @flow
export { default } from './ThumbnailCard';
